// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"vx_a bhn_b"};